module.exports = __webpack_public_path__ + "static/media/jay58.48b4a68a.png";